import React, { useEffect, useState } from 'react';
import { getFlowCriteria } from '../../api/decisions.api';
import FlowNavigationWrapper from '../../components/flow/FlowNavigationWrapper';
import Loading from '../../components/loading/Loading';
import { useError } from '../../context/error-context';

const FlowPage = ({ flowId }: {
    flowId: string | undefined
}) => {
    const [ flowData, setFlowData ] = useState<any>(null);
    const [ loading, setLoading ] = useState(true);
    const { showError } = useError();

    useEffect(() => {
        if (!flowId) {
            return;
        }

        getFlowCriteria(flowId)
        .then(response => {
            setFlowData(response);
        })
        .catch((err) => {
                showError({
                    code: err.response?.status || 500,
                    message: "API Error",
                    description: "Failed to fetch data",
                    showRefresh: true,
                })
            })
        .finally(() => setLoading(false));
    }, [ flowId, showError]);

    if (loading) {
        return <Loading/>;
    }
    if (!flowData) {
        return null;
    }

    return <FlowNavigationWrapper criteriaData={flowData}/>;
};

export default FlowPage;